/**
 *
 * 工具函数
 */

export const randomStr = (prefix?: string) => {
  const r1 = Math.random().toString(32);
  const r2 = Date.now().toString(32);
  return `${prefix}${r1.slice(3)}${r2}`;
};
